export const PAGE_TITLE = 'Retail Planning';
export const TAB_CONTENT_TITLE = 'Retail plan';
export const SYNC_BTN = 'Sync';
export const REGENERATE_BTN = 'Re-Gen Plan';
export const TIME_STAMP_CONFIG = {
  PLAN_GENERATOR: {
    label: 'Plan Generated at - ',
    key: 'planGenerated',
  },
  PLAN_UPDATED: {
    label: 'Plan Updated at - ',
    key: 'planUpdated',
  },
};
